/* ***** ----------------------------------------------- ***** **
** ***** Lazy Load JS
** ***** ----------------------------------------------- ***** */

/* global jQuery, Main, TweenMax, Power2, */
(function($){
	'use strict';

	Main.modules.lazyLoad = function() {

		var $postPreviewDataSrc = $('[data-src]'),
			fadeInDuration = 0.8,
			yOffset = 400,
			windowHeight = $(window).height(),
			windowWidth = $(window).width(),

			lazyLoad = function() {

				// Cycle through all elements with [data-src] and set the background image
				$postPreviewDataSrc.each(function() {
					var $this = $(this),
						$thisParent = $this.parent(),
						thisSrc = $this.data('src');

					if (isInViewport(this) && thisSrc != '') {

						// Set parent of element to invisible
						$thisParent.css('opacity', 0);

						// Ensures the image is loaded before fading in for a smoother transition
						$('<img/>').attr('src', thisSrc).load(function() {
							(this).remove(); // prevent memory leaks
							
							// Set image as background url from data attribute
							$this.css('background-image', 'url("' + thisSrc + '")');
							$this.removeAttr('data-src');

							// Fade parent in as background image is loaded and user scrolls past it
							TweenMax.to($thisParent, fadeInDuration, {
								opacity: 1,
								ease: Power2.easeOut
							});
						});
					}

				});

			},

			isInViewport = function(element) {

				// Check whether element is in viewport + offset
				var rectangle = element.getBoundingClientRect();

				return (
					rectangle.top >= 0 &&
					rectangle.left >= 0 &&
					rectangle.bottom <= (windowHeight + yOffset) &&
					rectangle.right <= windowWidth
				);

			};

		return {
			init: function() {
				lazyLoad();
			},
			lazyLoad: lazyLoad
		}
		
	};

})(jQuery);